import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	readMore: {
		id: 'issue-create.modal.create-form.smart-field-message.read-more',
		defaultMessage:
			'We’ve surfaced the fields you use often, and hidden the ones you don’t. <link>More about this change</link>',
		description: 'Message shown in issue create modal explaining about smart fields feature.',
	},
	dismissButtonLabel: {
		id: 'issue-create.modal.create-form.smart-field-message.dismiss-button-label',
		defaultMessage: 'Dismiss this message',
		description: 'Label for dismiss button in smart fields message.',
	},
});
